import User, { Role } from "@/data/models/User";
import {TaskType} from "./Task";

export enum Qualification {
  LEAK_DETECTION,
  BIG_DAMAGE_ASSESSMENT,
  SMALL_DAMAGE_ASSESSMENT,
  DRYING,
  RESTORATION,
  REPAIR,
}

export function getQualificationsOfRole(role: Role): Qualification[] {
  switch (role) {
    case Role.LEAK_DETECTION: {
      return [
        Qualification.LEAK_DETECTION,
        Qualification.SMALL_DAMAGE_ASSESSMENT,
      ];
    }
    case Role.PROJECT_MANAGER: {
      return [
        Qualification.LEAK_DETECTION,
        Qualification.BIG_DAMAGE_ASSESSMENT,
        Qualification.SMALL_DAMAGE_ASSESSMENT,
        Qualification.DRYING,
        Qualification.RESTORATION,
      ];
    }
    case Role.TECHNICIAN_1: {
      return [
        Qualification.SMALL_DAMAGE_ASSESSMENT,
        Qualification.DRYING,
        Qualification.RESTORATION,
        Qualification.REPAIR,
      ];
    }
    case Role.TECHNICIAN_2: {
      return [Qualification.DRYING, Qualification.RESTORATION];
    }
    case Role.TECHNICIAN_AND_LEAK_DETECTION: {
      return [
        Qualification.LEAK_DETECTION,
        Qualification.BIG_DAMAGE_ASSESSMENT,
        Qualification.DRYING,
        Qualification.RESTORATION,
        Qualification.REPAIR,
      ];
    }
    case Role.ADMIN: {
      return [Qualification.BIG_DAMAGE_ASSESSMENT];
    }
  }

  return [];
}

export function getQualificationsOfUser(user: User): Qualification[] {
  const role = user.role;

  return role ? getQualificationsOfRole(role) : [];
}

export function hasUserRequieredQualfications(
  qualificationsOfUser: Set<Qualification> | null | undefined,
  requiredQualifications: Qualification[]
) {
  if (requiredQualifications.length === 0) {
    return true;
  }

  if (!qualificationsOfUser) {
    return false
  }

  return requiredQualifications.every((requiredQualification) =>
    qualificationsOfUser.has(requiredQualification)
  );
}

export function getRequieredQualificationsForTaskType(taskType: TaskType): Qualification[] {
  switch (taskType) {
    case TaskType.LEAK_DETECTION:
      return [Qualification.LEAK_DETECTION]
    case TaskType.DAMAGE_ASSESSMENT:
      return [Qualification.BIG_DAMAGE_ASSESSMENT]
    case TaskType.DRYING_SETUP:
      return [Qualification.DRYING]
    case TaskType.INTERMEDIATE_MEASUREMENT:
      return [Qualification.DRYING]
    case TaskType.DRYING_CONCLUSION:
      return [Qualification.DRYING]
    case TaskType.REPAIR:
      return [Qualification.REPAIR]
  }
}
